const COUNTRIES = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Germany",
  "France",
  "India",
  "Brazil",
];

const NOTIFICATION_OPTIONS = [
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "Whatsapp" },
  { value: "both", label: "Both Email & WhatsApp" },
];

module.exports = { COUNTRIES, NOTIFICATION_OPTIONS };
